import { SingleSelectOption } from "@/components/controls/SingleSelect";
import type { SavedAttachmentInfo } from "@/entities/attachments/types";
import { FieldType, ResponseType } from "./shared";

export interface DateRangeControlValue {
  fromDate: string;
  toDate: string;
}

export interface CheckboxWithTextControlValue {
  checked: boolean;
  text: string;
}

export type FieldControlValue =
  | string
  | number
  | boolean
  | string[]
  | SavedAttachmentInfo[]
  | DateRangeControlValue
  | CheckboxWithTextControlValue
  | undefined;

export interface MultiSelectSlots {
  showSearch?: boolean;
  onSearch?: (searchValue: string) => void;
  searchPlaceholder?: string;
  popOverFooter?: JSX.Element | ((searchTerm: string) => JSX.Element);
  maxCount?: number;
}

export interface SingleSelectSlots {
  variant?: "inline" | "dropdown";
  sideOffset?: number;
}

export interface FieldControlProps {
  fieldType: FieldType;
  config?: ResponseType & { textAreaQuestion?: string };
  value: FieldControlValue;
  onChange: (value: FieldControlValue) => void;
  name: string;
  options?: SingleSelectOption[];
  checkboxLabel?: string;
  multiSelect?: MultiSelectSlots;
  singleSelect?: SingleSelectSlots;
  showNumberHints?: boolean;
  dateVariant?: "badge" | "field";
  className?: string;
}

export type ControlProps = Omit<FieldControlProps, "className">;

export const asString = (value: FieldControlValue): string =>
  typeof value === "string" || typeof value === "number" ? String(value) : "";
